export const FEED_CREATE_RESET = "FEED_CREATE_RESET";
export const FEED_CREATE_SET_CREATED = "FEED_CREATE_SET_CREATED";
export const FEED_CREATE_SET_ERROR = "FEED_CREATE_SET_ERROR";
export const FEED_CREATE_SET_VIOLATIONS = "FEED_CREATE_SET_VIOLATIONS";
export const FEED_CREATE_TOGGLE_LOADING = "FEED_CREATE_TOGGLE_LOADING";
